<template>
  <section class="jackpot-box" :aria-label="$t('jackpot.title')">
    <div class="jackpot-banner-v4">
      <div class="jackpot-banner-v4__glow-line jackpot-banner-v4__glow-line--top" aria-hidden="true" />
      <div class="jackpot-banner-v4__glow-line jackpot-banner-v4__glow-line--bottom" aria-hidden="true" />

      <i
        v-for="spark in sparks"
        :key="spark"
        class="jackpot-banner-v4__spark"
        :class="'jackpot-banner-v4__spark--' + spark"
        aria-hidden="true"
      />
      <i
        v-for="coin in coins"
        :key="coin"
        class="jackpot-banner-v4__coin"
        :class="'jackpot-banner-v4__coin--' + coin"
        aria-hidden="true"
      />

      <div class="jackpot-banner-v4__body">
        <div class="jackpot-banner-v4__badge" aria-hidden="true">
          <span class="jackpot-banner-v4__badge-crown">♛</span>
          <span class="jackpot-banner-v4__badge-label">JACKPOT</span>
        </div>

        <div class="jackpot-banner-v4__headline-wrap">
          <h3 class="jackpot-banner-v4__headline">
            <span class="jackpot-banner-v4__wing">═</span>
            {{ $t('jackpot.title') }}
            <span class="jackpot-banner-v4__wing">═</span>
          </h3>
        </div>

        <div class="jackpot-banner-v4__counter-shell">
          <div class="jackpot-banner-v4__counter-inner">
            <div class="jackpot-banner-v4__won">{{ siteCurrency }}</div>
            <JackpotV4Digits :amount="jackpotAmount" />
          </div>
        </div>

        <div class="jackpot-banner-v4__live">
          <span class="jackpot-banner-v4__live-dot" aria-hidden="true" />
          <span class="jackpot-banner-v4__live-text">{{ $t('jackpot.live') }}</span>
        </div>

        <div class="jackpot-banner-v4__footer">
          <span>{{ $t('jackpot.slogan') }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import JackpotV4Digits from '@/components/black-gold/JackpotV4Digits.vue'
import {
  createJackpotDisplayAmount,
  getJackpotTickDelta,
  getJackpotTickPauseMs,
  getJackpotTickTarget,
  persistJackpotDisplayAmount
} from '@/utils/jackpot'

/** siteInfo 도착 전 임시 표시값 (USD 기준: 약 $42,000 ~ $285,000) */
function fallbackJackpotAmount () {
  return 42000 + Math.floor(Math.random() * 243000)
}

export default {
  name: 'BlackGoldJackpotBox',

  components: { JackpotV4Digits },

  data () {
    return {
      sparks: ['s1', 's2', 's3', 's4', 's5'],
      coins: ['c1', 'c2', 'c3'],
      jackpotAmount: 0,
      tickTimer: null
    }
  },

  watch: {
    '$store.state.siteInfo': {
      handler (siteInfo) {
        if (!siteInfo || this.jackpotAmount > 0) return
        this.jackpotAmount = createJackpotDisplayAmount(siteInfo)
      },
      immediate: true
    }
  },

  mounted () {
    if (this.jackpotAmount <= 0) {
      this.jackpotAmount = fallbackJackpotAmount()
    }
    this.startTickLoop()
  },

  beforeDestroy () {
    this.stopTickLoop()
  },

  methods: {
    startTickLoop () {
      this.stopTickLoop()
      const runTick = () => {
        if (this.jackpotAmount <= 0) {
          const siteInfo = this.$store.state.siteInfo
          this.jackpotAmount = siteInfo
            ? createJackpotDisplayAmount(siteInfo)
            : fallbackJackpotAmount()
        }

        const siteInfo = this.$store.state.siteInfo
        const start = this.jackpotAmount
        const delta = siteInfo ? getJackpotTickDelta(siteInfo) : (1000 + Math.floor(Math.random() * 2001))
        const target = siteInfo
          ? getJackpotTickTarget(siteInfo, start, delta)
          : { end: start + delta, rollover: false, resetAmount: null }
        const end = target.rollover ? target.resetAmount : target.end

        this.jackpotAmount = end
        if (siteInfo) {
          persistJackpotDisplayAmount(siteInfo, end)
        }

        const pause = siteInfo ? getJackpotTickPauseMs(siteInfo) : 3000
        this.tickTimer = window.setTimeout(runTick, pause)
      }

      this.tickTimer = window.setTimeout(runTick, 3000)
    },

    stopTickLoop () {
      if (this.tickTimer) {
        clearTimeout(this.tickTimer)
        this.tickTimer = null
      }
    }
  }
}
</script>
